export const fieldTranslations = {
  // Time series fields
  date: "Date",
  c8_static_datum_name: "Actif",
  c8_static_datum_id: "ID de l'actif",
  fixing: "Prix unitaire",
  market_value: "Valorisation",
  currency: "Devise",

  // Technical fields
  created_at: "Créé le",
  updated_at: "Mis à jour le",
};

export default fieldTranslations;
